import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { GameCard } from '../components/GameCard';
import { games } from '../games/registry';
import { getTranslation } from '../localization/translations';
import { useApp } from '../app/AppContext';

export function HomePage() {
  const { settings, setSettings, profiles, progress } = useApp();
  const t = getTranslation(settings.language);
  const profile = profiles.find((item) => item.id === settings.activeProfileId);
  const stars = progress?.totalStars ?? 0;

  return <section className="home-library page-width">
    <motion.header className="home-library__header" initial={{ opacity: 0, y: -16 }} animate={{ opacity: 1, y: 0 }}>
      <div className="home-library__welcome"><span className="eyebrow">🌈 {t.allGames}</span><h1>{t.chooseGame}</h1><p>{t.tagline}</p></div>
      <div className="home-library__status">
        <Link className="profile-pill" to="/parents" aria-label={`${profile?.name ?? 'Explorer'} profile`}><span aria-hidden="true">🐉</span><strong>{profile?.name ?? 'Explorer'}</strong></Link>
        <Link className="home-star-pill" to="/rewards" aria-label={`${stars} ${t.stars}`}><span aria-hidden="true">⭐</span><strong>{stars}</strong><small>{t.stars}</small></Link>
        <div className="home-language-switch" aria-label="Language"><button className={settings.language === 'en' ? 'active' : ''} onClick={() => setSettings({ language: 'en' })} aria-pressed={settings.language === 'en'}>EN</button><button className={settings.language === 'ms' ? 'active' : ''} onClick={() => setSettings({ language: 'ms' })} aria-pressed={settings.language === 'ms'}>BM</button></div>
      </div>
    </motion.header>
    <div className="game-grid game-grid--library game-grid--home" data-testid="home-game-grid">{games.map((game, index) => <GameCard key={game.id} game={game} index={index}/>)}</div>
  </section>;
}
